<template>
    <AppLayout>
        <div class="container pt-4 mx-auto md:px-1">
            <div class="px-2 py-1 duration-100 ease-linear transform">
                <div class="mb-4 text-l font-semibold md:text-2xl text-center">
                    <span>Coming soon </span>
                    (Professional developers are working on it.)
                </div>
                <img
                    class="object-cover"
                    :src="mblAppBg"
                    alt="app store"
                >
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from '../../Layouts/AppLayout.vue';

export default {
    name: 'AppStoreIndex',

    components: {
        AppLayout,
    },

    computed: {
        mblAppBg() {
            return `${process.env.MIX_SENTRY_DSN_PUBLIC}/storage/default/bg_appstore.jpg`;
        },
    },
};
</script>
